import { UAParser } from 'ua-parser-js'

import type { DeviceInfoProps } from './types'

export function useDeviceInfo(): DeviceInfoProps {
  const uaParser = new UAParser(navigator.userAgent)
  const device = uaParser.getDevice()

  return {
    deviceType: device?.type?.toUpperCase() || 'DESKTOP',
    deviceVendor: device?.vendor?.toUpperCase() || '',
    deviceModel: device?.model?.toUpperCase() || ''
  }
}
